
export default class Pagination {
	constructor(domContainer, config) {
		// the LIST of containers, a page can display more than one single pagination (top and bottom)
		this.domContainer = domContainer;

		this.config = {
			currentPage: 1,
			itemsPerPage: 8,
			activeClass: 'current',
			...config
		};
	}

	/**
	 * Creates the pagination display.
	 * 
	 * @param {integer} countResults
	 */
	createPagination(countResults) {
		this.domContainer.forEach(pagination => {
			let totalPages = Math.ceil(countResults/this.config.itemsPerPage)+1;
			let pageNumbersStart = Math.max(1, this.config.currentPage - 3);
			let limitCount = 7;

			let ul = document.createElement('ul');
				ul.classList.add('dc-nav');
				
				if (this.config.currentPage >= 4) {
					// First button - optional and doesn't impact the pagenumers start
					let li = document.createElement('li');
					li.classList.add(...[ 'dc-nav-page', 'dc-nav-first' ]);
					let a = document.createElement('a');
					a.href = '#';
					a.innerHTML = `${pagination.getAttribute('data-first') || '&larrb;'} <span class="count">1</span>`;
					a.setAttribute('data-page', 1);
					
					a.addEventListener('click', e => {
						e.preventDefault();
						
						this.scrollTo(pagination);
						// Back to Result.js
						this.config.onChangePage(1);
					});
					li.appendChild(a);
					ul.appendChild(li);
				}

				if (this.config.currentPage > 1) {
					let li = document.createElement('li');
						li.classList.add(...[ 'dc-nav-page', 'dc-nav-prev' ]);
					let a = document.createElement('a');
					a.href = '#';
					a.innerHTML = pagination.getAttribute('data-prev') || '&larr;';
					a.setAttribute('data-page', this.config.currentPage-1);

					a.addEventListener('click', e => {
						e.preventDefault();

						this.scrollTo(pagination);
						// Back to Result.js
						this.config.onChangePage(parseInt(e.target.getAttribute('data-page')));
					});
					li.appendChild(a);
					ul.appendChild(li);

					--limitCount;
					++pageNumbersStart;
				}
			if (this.config.currentPage < totalPages-3) {
				--limitCount;
			}

			for (let i = pageNumbersStart; i < totalPages && i < pageNumbersStart+limitCount; ++i) {
				let li = document.createElement('li');
					li.classList.add(...[ 'dc-nav-page' ]);
				let a = document.createElement('a');
					a.href = '#';
					a.innerHTML = i;
					a.setAttribute('data-page', i);
				a.addEventListener('click', e => {
					e.preventDefault();

					this.scrollTo(pagination);
					// Back to Result.js
					this.config.onChangePage(parseInt(e.target.getAttribute('data-page')));
				});
				li.appendChild(a);
				ul.appendChild(li);
			}

			if (this.config.currentPage < totalPages-1) {
				let li = document.createElement('li');
				li.classList.add(...[ 'dc-nav-page', 'dc-nav-next' ]);
				let a = document.createElement('a');
					a.href = '#';
					a.innerHTML = pagination.getAttribute('data-next') || '&rarr;';
					a.setAttribute('data-page', this.config.currentPage+1);

					a.addEventListener('click', e => {
						e.preventDefault();

						this.scrollTo(pagination);
						// Back to Result.js
						this.config.onChangePage(parseInt(e.target.getAttribute('data-page')));
					});
				li.appendChild(a);
				ul.appendChild(li);
			}

			if (this.config.currentPage < totalPages-3) {
				let li = document.createElement('li');
				li.classList.add(...[ 'dc-nav-page', 'dc-nav-last' ]);
				// First button - optional and doesn't impact the pagenumers start
				let a = document.createElement('a');
				a.href = '#';
				a.innerHTML = `<span class="count">${totalPages-1}</span> ${pagination.getAttribute('data-last') || '&rarro;'}`;
				a.setAttribute('data-page', totalPages-1);

				a.addEventListener('click', e => {
					e.preventDefault();

					this.scrollTo(pagination);
					// Back to Result.js
					this.config.onChangePage(totalPages-1);
				});
				li.appendChild(a);
				ul.appendChild(li);
			}

			pagination.innerHTML = '';
			pagination.appendChild(ul);

			let curPage = pagination.querySelector('a[data-page="'+ this.config.currentPage +'"]')
			if (curPage) {
				curPage.parentNode.classList.add(this.config.activeClass);
			}
		});
	}

	/**
	 * Sets the active page.
	 */
	setPage(iPage, countTotalResults) {
		this.config.currentPage = iPage;
		this.createPagination(countTotalResults);
	}

	scrollTo(pagination) {
		if (pagination.hasAttribute('data-scroll-target')) {
			let scrollTarget = document.querySelector(pagination.getAttribute('data-scroll-target'));
			if (scrollTarget) {
				scrollTarget.scrollIntoView({
					behavior: 'smooth', block: 'start'
				});
			}
		}
	}
}
